// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
  font-size: 14px;
  font-weight: 600;
  border-radius: 2px;
  padding-left: 14px;
}

.reason {
  font-size: 12px;
  font-weight: 600;
}

.selectionBox1 {
  position: relative;
  top: 25px;
}

.reason1 {
  display: inline-block;
  position: absolute;
  font-size: 12px;
  left: 52%;
  font-weight: 600;
  top: 7px;
}

.card {
  width: 100%;
  padding: 0px 15px 0px 15px;
  margin-top: 20px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.fa-angle-right {
  font-weight: 600;
  margin-right: 10px;
}

.fa-angle-down {
  font-weight: 600;
  margin-right: 10px;
}

.item {
  margin-left: 2%;
}
.item .info {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  align-items: center;
}
.item .info-text {
  font-weight: normal;
  font-style: normal;
  font-size: 16px;
  align-items: center;
}

.divider {
  border-left: 1px solid #c4c4c4;
}

label.checkbox > span:before {
  /* stylelint-disable-next-line*/
  font: normal normal normal 14px/1 FontAwesome;
  text-rendering: auto;
  content: " ";
  width: 16px;
  height: 16px;
  border-radius: 2px;
  display: inline-block;
  line-height: 16px;
  font-size: 17px;
  margin-left: -14px;
  font-weight: 100;
  text-align: center;
  vertical-align: top;
  cursor: pointer;
  border: 1px solid var(--color-primary);
  margin-top: 6px;
}

input[type=checkbox] {
  display: none;
}

.list {
  margin: 7px 0px 0px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  order: 1;
  text-align: right;
}
.list .detail-toggle {
  cursor: pointer;
  border: none;
  color: var(--color-interaction-text);
}
.list .detail-toggle .fa {
  margin-right: 3%;
}

.list-nonreturnable {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  order: 1;
  margin: 14px 0px 0px 0px;
  text-align: right;
}
.list-nonreturnable .detail-toggle {
  border: none;
  color: var(--color-interaction-text);
}
.list-nonreturnable .detail-toggle .fa {
  margin-right: 3%;
}

.non-returnable-card {
  background-color: #fafafa;
}

.non-returnable-item {
  display: flex;
  color: #666;
}

.non-returnable-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.non-returnable-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.non-returnable-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.non-returnable-media {
  display: flex;
  align-items: center;
}

.non-returnable-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: 1px solid #b5b5b5;
  background-color: #efefef;
  flex-shrink: 0;
}

.non-returnable-image {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 4px;
  mix-blend-mode: multiply;
  background-color: transparent;
  margin-right: 0;
}

.non-returnable-alt-text {
  font-size: 12px;
  color: #8a8a8a;
  max-width: 70px;
  line-height: 1.2;
}

.non-returnable-label {
  display: inline-flex;
  align-self: flex-start;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid #d3d3d3;
  background-color: #f1f1f1;
  color: #666;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
}

.itemInfo {
  margin: 20px 0px 20px 0px;
}

select {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  padding: 0px 0px 7px 0px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
}

.is-invalid {
  border-bottom: 2px solid var(--color-error);
}

.component {
  margin-top: 5%;
  padding-left: 0px;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
}

.hide {
  margin-top: 7%;
}

.item-name-elepsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 170px;
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  font-style: normal;
}

.item-name {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  font-style: normal;
}

.invalid-feedback {
  color: var(--color-error);
  font-size: 16px;
}

.d-flex {
  gap: 0rem;
}

.item {
  flex: 0 1 100px;
}

.item-details {
  margin: 20px 0px 20px 0;
  white-space: nowrap;
  padding: 0px;
}

.externalIntegration-image {
  width: 136px;
  height: 161px;
  margin-right: 16px;
}

.externalIntegration-noImage {
  width: 136px;
  height: 161px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/return-items/return-order-details/return-items-details.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,QAAA;AACF;;AACA;EACE,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAEF;;AAAA;EACE,gBAAA;EACA,kBAAA;AAGF;;AADA;EACE,gBAAA;EACA,kBAAA;AAIF;;AADA;EACE,eAAA;AAIF;AAHE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAKJ;AAHE;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAKJ;;AADA;EACE,8BAAA;AAIF;;AAFA;EACE,+BAAA;EACA,6CAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,eAAA;AAKF;;AAFA;EACE,aAAA;AAKF;;AAFA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;AAKF;AAJE;EACE,eAAA;EACA,YAAA;EACA,oCAAA;AAMJ;AALI;EACE,gBAAA;AAON;;AAFA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;EACA,wBAAA;EACA,iBAAA;AAKF;AAJE;EACE,YAAA;EACA,oCAAA;AAMJ;AALI;EACE,gBAAA;AAON;;AAFA;EACE,yBAAA;AAKF;;AAFA;EACE,aAAA;EACA,WAAA;AAKF;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;EACA,eAAA;AAKF;;AAFA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAKF;;AAFA;EACE,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAHA;EACE,YAAA;EACA,6CAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAMF;;AAJA;EACE,2CAAA;AAOF;;AALA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAQF;;AALA;EACE,cAAA;AAQF;;AALA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAQF;;AANA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AASF;;AANA;EACE,yBAAA;EACA,eAAA;AASF;;AALA;EACE,SAAA;AAQF;;AANA;EACE,eAAA;AASF;;AANA;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;AASF;;AANA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AASF;;AANA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AASF","sourcesContent":[".custom-select {\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 2px;\n  padding-left: 14px;\n}\n\n.reason {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.selectionBox1 {\n  position: relative;\n  top: 25px;\n}\n\n.reason1 {\n  display: inline-block;\n  position: absolute;\n  font-size: 12px;\n  left: 52%;\n  font-weight: 600;\n  top: 7px;\n}\n.card {\n  width: 100%;\n  padding: 0px 15px 0px 15px;\n  margin-top: 20px;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n.fa-angle-right {\n  font-weight: 600;\n  margin-right: 10px;\n}\n.fa-angle-down {\n  font-weight: 600;\n  margin-right: 10px;\n}\n\n.item {\n  margin-left: 2%;\n  .info {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    align-items: center;\n  }\n  .info-text {\n    font-weight: normal;\n    font-style: normal;\n    font-size: 16px;\n    align-items: center;\n  }\n}\n\n.divider {\n  border-left: 1px solid #c4c4c4;\n}\nlabel.checkbox > span:before {\n  /* stylelint-disable-next-line*/\n  font: normal normal normal 14px/1 FontAwesome;\n  text-rendering: auto;\n  content: \" \";\n  width: 16px;\n  height: 16px;\n  border-radius: 2px;\n  display: inline-block;\n  line-height: 16px;\n  font-size: 17px;\n  margin-left: -14px;\n  font-weight: 100;\n  text-align: center;\n  vertical-align: top;\n  cursor: pointer;\n  border: 1px solid var(--color-primary);\n  margin-top: 6px;\n}\n\ninput[type=\"checkbox\"] {\n  display: none;\n}\n\n.list {\n  margin: 7px 0px 0px 0px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  order: 1;\n  text-align: right;\n  .detail-toggle {\n    cursor: pointer;\n    border: none;\n    color: var(--color-interaction-text);\n    .fa {\n      margin-right: 3%;\n    }\n  }\n}\n\n.list-nonreturnable {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  order: 1;\n  margin: 14px 0px 0px 0px;\n  text-align: right;\n  .detail-toggle {\n    border: none;\n    color: var(--color-interaction-text);\n    .fa {\n      margin-right: 3%;\n    }\n  }\n}\n\n.non-returnable-card {\n  background-color: #fafafa;\n}\n\n.non-returnable-item {\n  display: flex;\n  color: #666;\n}\n\n.non-returnable-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.non-returnable-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.non-returnable-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.non-returnable-media {\n  display: flex;\n  align-items: center;\n}\n\n.non-returnable-checkbox {\n  width: 16px;\n  height: 16px;\n  border-radius: 2px;\n  border: 1px solid #b5b5b5;\n  background-color: #efefef;\n  flex-shrink: 0;\n}\n\n.non-returnable-image {\n  width: 56px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: 4px;\n  mix-blend-mode: multiply;\n  background-color: transparent;\n  margin-right: 0;\n}\n\n.non-returnable-alt-text {\n  font-size: 12px;\n  color: #8a8a8a;\n  max-width: 70px;\n  line-height: 1.2;\n}\n\n.non-returnable-label {\n  display: inline-flex;\n  align-self: flex-start;\n  padding: 3px 10px;\n  border-radius: 999px;\n  border: 1px solid #d3d3d3;\n  background-color: #f1f1f1;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.itemInfo {\n  margin: 20px 0px 20px 0px;\n}\nselect {\n  border: none;\n  border-bottom: 2px solid var(--color-primary);\n  padding: 0px 0px 7px 0px;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n}\n.is-invalid {\n  border-bottom: 2px solid var(--color-error);\n}\n.component {\n  margin-top: 5%;\n  padding-left: 0px;\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n}\n\n.hide {\n  margin-top: 7%;\n}\n\n.item-name-elepsis {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 170px;\n  margin: 0;\n  font-weight: 600;\n  font-size: 18px;\n  font-style: normal;\n}\n.item-name {\n  margin: 0;\n  font-weight: 600;\n  font-size: 18px;\n  font-style: normal;\n}\n\n.invalid-feedback {\n  color: var(--color-error);\n  font-size: 16px;\n}\n\n\n.d-flex {\n  gap: 0rem;\n}\n.item {\n  flex: 0 1 100px;\n}\n\n.item-details {\n  margin: 20px 0px 20px 0;\n  white-space: nowrap;\n  padding: 0px;\n}\n\n.externalIntegration-image{\n  width: 136px;\n  height: 161px;\n  margin-right: 16px\n}\n\n.externalIntegration-noImage{\n  width: 136px;\n  height: 161px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
